import { createI18n } from 'vue-i18n'

function loadLocaleMessages () {
	const localeFiles = import.meta.glob('/src/locales/**/*.json', { eager: true })
	const messages = {}
	Object.keys(localeFiles).forEach(key => {
		const matched = key.match(/\/src\/locales\/([A-Za-z0-9-_]+)\.json$/i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = localeFiles[key].default || localeFiles[key]
		}
	})
	return messages
}

export default createI18n({
	legacy: false,
	locale: import.meta.env.VITE_I18N_LOCALE || 'pt',
	fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
	messages: loadLocaleMessages(),
	warnHtmlMessage: false
})
